import type { RoomRequestListQuery } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'
import { type RoomRequestAnswer, roomRequestsApi } from '../api/room-requests-api'

const REFRESH_MS = MINUTES

type RequestStatus = RoomRequestListQuery['status']

/** Requests to join one event on request, by status, with the counts for every status. */
export function useRoomRequests(businessId: string, eventId: string, status: RequestStatus) {
  return useQuery({
    queryKey: queryKey(QueryKey.EVENT_ROOM_REQUESTS, eventId, status),
    queryFn: () => roomRequestsApi.list(businessId, eventId, status),
    enabled: !!businessId && !!eventId,
    refetchInterval: REFRESH_MS,
  })
}

export function useAnswerRoomRequest(businessId: string, eventId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ requestId, answer }: { requestId: string; answer: RoomRequestAnswer }) =>
      roomRequestsApi.answer(businessId, eventId, requestId, answer),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.EVENT_ROOM_REQUESTS, eventId),
      })
      queryClient.invalidateQueries({ queryKey: queryKey(QueryKey.EVENTS, businessId) })
    },
  })
}
